module.exports = __webpack_public_path__ + "static/media/barkAndLight.f15746a0.jpg";